import { objectsFilter } from 'src/logic'
import { PartialActionDispatch, ResponseDispatch, StateObj } from 'src/types'

export const useOriginDispatcher = (DISPATCHER: any, key: string, dispatch: PartialActionDispatch, stateObjects: StateObj[]): ResponseDispatch => {
  return (selected: string) => {
    dispatch({
      type: DISPATCHER[key],
      [key]: objectsFilter(selected, stateObjects)
    })
  }
}
